// src/config/config.js
const config = {
  // API_URL: "http://localhost:8000/api",
  // API_URL: "https://eamsquare.in/backend/public/api",
  API_URL: "https://eamsquare.com/backend/public/api",
};

export default config;
